import colors from '../colors';
// Define all the component palettes inline
import alertPalette from './componentPallete/Alert/alert';
import avatarPalette from './componentPallete/Avatar/avatar';
import badgePalette from './componentPallete/Badge/badge';
import buttonPalette from './componentPallete/Button/button';
import cardPalette from './componentPallete/Card/card';
import chipPalette from './componentPallete/Chip/chip';
import dialogPalette from './componentPallete/Dialog/dialog';
import dividerPalette from './componentPallete/Divider/divider';
import iconButtonPalette from './componentPallete/IconButton/iconButton';
import iconPalette from './componentPallete/Icon/icon';
import linearProgressPalette from './componentPallete/LinearProgress/linearProgress';
import linkPalette from './componentPallete/LInk/link';
import menuItemPallete from './componentPallete/MenuItem/menuItem';
import menuPallete from './componentPallete/Menu/menu';
import navigationPalette from './componentPallete/Navigation/navigation';
import numberPalette from './componentPallete/Number/number';
import selectPalette from './componentPallete/Select/select';
import sizePalette from './componentPallete/Size/size';
import skeletonPalette from './componentPallete/Skeleton/skeleton';
import spacePalette from './componentPallete/Space/space';
import stepperPalette from './componentPallete/Stepper/stepper';
import switchPalette from './componentPallete/Switch/switch';
import tabPalette from './componentPallete/Tab/tab';
import textFieldPalette from './componentPallete/TextField/textField';
import toggleControlsPalette from './componentPallete/ToggleControls/toggleControls';
import tooltipPalette from './componentPallete/Tooltip/tooltip';
// Create the generatePalette function
export default function generatePalette(Tokens) {
    return {
        alert: alertPalette(Tokens),
        avatar: avatarPalette(Tokens),
        badge: badgePalette(Tokens),
        button: buttonPalette(Tokens),
        card: cardPalette(Tokens),
        chip: chipPalette(Tokens),
        customDivider: dividerPalette(Tokens),
        dialog: dialogPalette(Tokens),
        icon: iconPalette(Tokens),
        iconButton: iconButtonPalette(Tokens),
        linearProgress: linearProgressPalette(Tokens),
        link: linkPalette(Tokens),
        menu: menuPallete(Tokens),
        menuItem: menuItemPallete(Tokens),
        navigation: navigationPalette(Tokens),
        number: numberPalette(Tokens),
        select: selectPalette(Tokens),
        size: sizePalette(Tokens),
        skeleton: skeletonPalette(Tokens),
        space: spacePalette(Tokens),
        stepper: stepperPalette(Tokens),
        switch: switchPalette(Tokens),
        tab: tabPalette(Tokens),
        textField: textFieldPalette(Tokens),
        toggleControls: toggleControlsPalette(Tokens),
        tooltip: tooltipPalette(Tokens),
        // static
        common: {
            black: colors.black,
            white: colors.white
        },
        primary: {
            light: colors.blue500,
            main: colors.blue600,
            dark: colors.blue700,
            contrastText: colors.white
        },
        secondary: {
            light: colors.scaleGray500,
            main: colors.scaleGray600,
            dark: colors.scaleGray700,
            contrastText: colors.white
        },
        error: {
            light: colors.red300,
            main: colors.red600,
            dark: colors.red700,
            contrastText: colors.white
        },
        warning: {
            light: colors.redOrange300,
            main: colors.redOrange600,
            dark: colors.redOrange700,
            contrastText: colors.white
        },
        info: {
            light: colors.deepOcean300,
            main: colors.deepOcean600,
            dark: colors.deepOcean700,
            contrastText: colors.white
        },
        success: {
            light: colors.green300,
            main: colors.green600,
            dark: colors.green700,
            contrastText: colors.white
        },
        text: {
            primary: Tokens.aliasesColorTextStaticEmphasis,
            secondary: Tokens.aliasesColorTextStaticSubtle,
            disabled: Tokens.aliasesColorTextInteractiveDisabled
        },
        background: {
            default: Tokens.aliasesColorBgStaticContainerSubtle,
            paper: colors.white
        }
    };
}
//# sourceMappingURL=paletteTokens.js.map